import React, { useContext, useState, useEffect } from "react";
import { CodeContext } from "../../pages/Coder/Coder";
import CodingScreen from "../../CodingScreen/CodingScreen";
import CodeSearch from "../CodeSearch/CodeSearch";
import CodeSearchUSA from "../CodeSearch/CodeSearchUSA";

//import { CodeContextAll } from "../CodeAssistWrapper";

const CodeAssistWindow = ({
  showCodeSearch,
  enableFinalize,
  setShowCodeSearch,
  setHeaderText,
  setButtonText,
  onFinalizeCode,
  setIsFetchingData1,
  isFetchingData1,
  setAcceptedCodes,
  acceptedCodes,
  isDrgConfirmed,
  setEnableFinalize,
  auditedStatus,
  setAuditedStatus,
  handleCodeAssistAdding,
  validateCodeAPI,
  insertCode,
  // handleAccept,
  iconDisplay,
  setIconDispaly,
  saveToHistory,
  warningMessage,
  setWarningMessage,
  newlyInsertedCodes,
  setNewlyInsertedCodes,
  pendingCode,
  pendingType,
  setPendingCode,
  setPendingType,
  modalVisible,
  setModalVisible,
  modalMessage,
  setModalMessage,
  activeIcon,
  setActiveIcon,
  activeTab,
  setActiveTab,
  skipAcceptApi,
  nextClusterCurrentIndex,
  mvHours,
  setMvHours,
  nivHours,
  setNivHours,
  handleMvhoursupdation,
  deletedCodes,
  setDeletedCodes,
  triggerWarnings,
  hasDenyConfirmation,
  isCheckingWarnings,
  selectedActionType,
  setSelectedActionType,
  isBatchInsertingRef,
  batchInsertCompleted,
  setBatchInsertCompleted,
  hasCofOrClusterChanged,
  setHasCofOrClusterChanged,
  setShowMyActionsDropdown,
  hasCodesSequenced,
  setHasCodesSequenced,
  setActionPerformed,
  skipNextAutoDrgCalc,
  trackingIntervalRef,
  waitForUserActionRef,
  stopcoderSessionTimeCalculated,
  hasUnsavedChanges,
  fetchNudgingData,
  skipCategoryResetRef
}) => {
  useEffect(() => {
    setHeaderText(showCodeSearch ? "Code Search" : "Code Assist");
    setButtonText(showCodeSearch ? "CodeSearch" : "CodeAssist");
  }, [showCodeSearch, setHeaderText, setButtonText]);
  const codesearchusaEnv = process.env.REACT_APP_FLAG_USA;
  const {
    setCodeBookCard,
    episodeList,
    setDrgValue,
    setweightValue,
    setReimbursementValue,
    data1,
    isLoadingCodingScreen,
    setAccepted,
    diagnosisStates,
    setDiagnosisStates,
    setTrackHistory,
    setRedoStack,
    calculate_drg,
    finalizedCodeData,
    handleConfirmDrg,
  } = useContext(CodeContext);
  let [finalcode, setfilecode] = useState("");
  // useEffect(() => {
  //   console.log("Final code updated jyotiii", finalcode);
  // }, [finalcode]);
  //     console.log("Final code updated jyotiii", finalcode);
  return (
    <>
      {showCodeSearch ? (
        codesearchusaEnv ? (
          <CodeSearchUSA
            setShowCodeSearch={setShowCodeSearch}
            codingscreendata={data1}
            setfilecode={setfilecode}
            finalcode={finalcode}
            isFetchingData1={isFetchingData1}
            setIsFetchingData1={setIsFetchingData1}
            enableFinalize={enableFinalize}
            handleCodeAssistAdding={handleCodeAssistAdding}
            activeTab={activeTab}
            activeIcon={activeIcon}
            setActiveTab={setActiveTab}
            setActiveIcon={setActiveIcon}
          />
        ) : (
          <CodeSearch
            setShowCodeSearch={setShowCodeSearch}
            codingscreendata={data1}
            setfilecode={setfilecode}
            finalcode={finalcode}
            isFetchingData1={isFetchingData1}
            setIsFetchingData1={setIsFetchingData1}
            enableFinalize={enableFinalize}
            handleCodeAssistAdding={handleCodeAssistAdding}
            activeTab={activeTab}
            activeIcon={activeIcon}
            setActiveTab={setActiveTab}
            setActiveIcon={setActiveIcon}
            diagnosisStates={diagnosisStates}
            skipCategoryResetRef={skipCategoryResetRef}
          />
        )
      ) : (
        <>
          <CodingScreen
            setCodeBookCard={setCodeBookCard}
            episodeListData={episodeList}
            setDrgValue={setDrgValue}
            setweightValue={setweightValue}
            setReimbursementValue={setReimbursementValue}
            codingscreendata={data1}
            isLoadingCodingScreen={isLoadingCodingScreen}
            setAccepted={setAccepted}
            diagnosisStates={diagnosisStates}
            setDiagnosisStates={setDiagnosisStates}
            setTrackHistory={setTrackHistory}
            setRedoStack={setRedoStack}
            setShowCodeSearch={setShowCodeSearch}
            finalcode={finalcode}
            calculate_drg={calculate_drg}
            handleConfirmDrg={handleConfirmDrg}
            isDrgConfirmed={isDrgConfirmed}
            isFetchingData1={isFetchingData1}
            setIsFetchingData1={setIsFetchingData1}
            acceptedCodes={acceptedCodes}
            setAcceptedCodes={setAcceptedCodes}
            setEnableFinalize={setEnableFinalize}
            enableFinalize={enableFinalize}
            auditedStatus={auditedStatus}
            setAuditedStatus={setAuditedStatus}
            handleCodeAssistAdding={handleCodeAssistAdding}
            validateCodeAPI={validateCodeAPI}
            insertCode={insertCode}
            // handleAccept={handleAccept}
            iconDisplay={iconDisplay}
            setIconDispaly={setIconDispaly}
            saveToHistory={saveToHistory}
            warningMessage={warningMessage}
            setWarningMessage={setWarningMessage}
            newlyInsertedCodes={newlyInsertedCodes}
            setNewlyInsertedCodes={setNewlyInsertedCodes}
            pendingCode={pendingCode}
            setPendingCode={setPendingCode}
            pendingType={pendingType}
            setPendingType={setPendingType}
            modalVisible={modalVisible}
            setModalVisible={setModalVisible}
            modalMessage={modalMessage}
            setModalMessage={setModalMessage}
            skipAcceptApi={skipAcceptApi}
            nextClusterCurrentIndex={nextClusterCurrentIndex}
            mvHours={mvHours}
            setMvHours={setMvHours}
            nivHours={nivHours}
            setNivHours={setNivHours}
            handleMvhoursupdation={handleMvhoursupdation}
            deletedCodes={deletedCodes}
            setDeletedCodes={setDeletedCodes}
            triggerWarnings={triggerWarnings}
            hasDenyConfirmation={hasDenyConfirmation}
            isCheckingWarnings={isCheckingWarnings}
            selectedActionType={selectedActionType}
            setSelectedActionType={setSelectedActionType}
            isBatchInsertingRef={isBatchInsertingRef}
            batchInsertCompleted={batchInsertCompleted}
            setBatchInsertCompleted ={setBatchInsertCompleted}
            showCodeSearch={showCodeSearch}
            hasCofOrClusterChanged={hasCofOrClusterChanged}
            setHasCofOrClusterChanged={setHasCofOrClusterChanged}
            hasCodesSequenced={hasCodesSequenced}
            setHasCodesSequenced={setHasCodesSequenced}
            setActionPerformed={setActionPerformed}
            setShowMyActionsDropdown={setShowMyActionsDropdown}
            skipNextAutoDrgCalc={skipNextAutoDrgCalc}
            trackingIntervalRef={trackingIntervalRef}
            stopcoderSessionTimeCalculated={stopcoderSessionTimeCalculated}
            hasUnsavedChanges={hasUnsavedChanges}
            waitForUserActionRef={waitForUserActionRef}
            fetchNudgingData={fetchNudgingData}
            skipCategoryResetRef={skipCategoryResetRef}

          />
        </>
      )}
    </>
  );
};

export default CodeAssistWindow;
